// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YYiTQ","newExpiryDate":"styles_newExpiryDate__1nxd8","footer":"styles_footer__3gE-l"};